import { IFromPrice, ISFCCGroupPrice } from '@gn-audio/core/api/pricing/models';
import { IGroup } from '@gn-audio/core/api/product-catalogue/models/group';
import { SegmentType } from '@gn-audio/core/common/enums';
import { Component, Input, Output } from 'angular-ts-decorators';

import template from './cg-customizer-product.component.html';

@Component({
  selector: 'cgCustomizerProduct',
  template,
})
export class CgCustomizerProductComponent {
  public static $inject: ReadonlyArray<string> = [];

  @Input() public product?: IGroup;
  @Input() public segmentType?: SegmentType;

  @Output() public onPriceLoaded?: (price: IFromPrice | ISFCCGroupPrice) => void;
}
